import {logger} from "@otto-ec/global-resources/debug";
import {hasCookieConsent} from "@otto-ec/nav_patternsson";

const log = logger("ft-nav.chekov.vertical-navigation-survey");

export async function setSurveyCookie () {
    if (await hasCookieConsent()) {
        const cookieName = 'ft-nav-vertikalNavigation-cookie';
        log.info(`Setting cookie '${cookieName}'`);
        document.cookie = `${cookieName}=true;max-age=3600;path=/`;
    }
}
